const PageNotFound = () => {
    return (
        <div className="container">
            <div className="error-container">
                <div style={{ textAlign: "center" }}>
                    <img src="/images/404.png" alt="Error" className="error-image" />
                    <h1 className="error-text">La pagina solicitada no ha sido encontrada😕</h1>
                </div>
                <style>
                    {`
                        .container {
                            background-color: #090a10; /* color de fondo oscuro */
                            display: flex; /* centra el contenido */
                            flex-direction: column; /* coloca el texto debajo del loading */
                            align-items: center;
                            justify-content: center;
                            height: 100vh; /* ocupa toda la pantalla */
                            width: 100vw;
                        }

                        .error-container {
                            display: flex; /* convierte el elemento en un contenedor flex */
                            align-items: center; /* centra el contenido horizontalmente */
                            justify-content: center; /* centra el contenido verticalmente */
                            height: 100vh;
                            width: 100vw;
                        }
                
                        .error-image {
                            margin: auto; /* centra la imagen */
                            width: 256px; /* tamaño de la imagen */
                            animation: blink 4s infinite; /* animación que se repite cada 2 segundos */
                        }
                
                        .error-text {
                            font-size: 35px;
                            font-family: "Poppins", sans-serif;
                            color: #303550;
                            animation: slide-down 1s ease-in-out; /* animación de deslizamiento */
                            margin-top: 16px; /* espacio entre la imagen y el texto */
                        }
                
                        @keyframes slide-down {
                            0% { transform: translateY(-100%); }
                            100% { transform: translateY(0); }
                        }
                
                        @keyframes blink {
                            0% { opacity: 1; }
                            50% { opacity: 0; }
                            100% { opacity: 1; }
                        }
                    `}
                </style>
            </div>
        </div>
    );
};

export default PageNotFound;
